module.exports = __webpack_public_path__ + "static/media/sort-shapes-down.2fc240f8.svg";